var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPNavSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3248 12.899L19.7048 18.279C19.8939 18.4682 20 18.7248 20 18.9924C19.9999 19.2599 19.8935 19.5164 19.7043 19.7055C19.515 19.8946 19.2584 20.0008 18.9909 20.0007C18.7234 20.0006 18.4669 19.8942 18.2778 19.705L12.8978 14.325C11.2895 15.5707 9.26705 16.1569 7.24189 15.9644C5.21674 15.7718 3.341 14.815 1.99625 13.2886C0.6515 11.7622 -0.0612416 9.78082 0.00301976 7.74755C0.0672812 5.71428 0.903718 3.78186 2.34217 2.34341C3.78063 0.904954 5.71305 0.0685171 7.74631 0.00425573C9.77958 -0.0600057 11.761 0.652736 13.2874 1.99749C14.8138 3.34224 15.7706 5.21798 15.9631 7.24313C16.1556 9.26828 15.5694 11.2907 14.3238 12.899H14.3248ZM7.99977 14C9.59107 14 11.1172 13.3679 12.2424 12.2426C13.3676 11.1174 13.9998 9.5913 13.9998 8C13.9998 6.4087 13.3676 4.88258 12.2424 3.75736C11.1172 2.63214 9.59107 2 7.99977 2C6.40847 2 4.88235 2.63214 3.75713 3.75736C2.63191 4.88258 1.99977 6.4087 1.99977 8C1.99977 9.5913 2.63191 11.1174 3.75713 12.2426C4.88235 13.3679 6.40847 14 7.99977 14Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPNavSearch);
export default __webpack_public_path__ + "static/media/p_nav_search.a7c09e3092927976df5854a167ce2c06.svg";
export { ForwardRef as ReactComponent };